<div *ngIf="!loading && opcionesFuncion">
  <div style="margin-top: 2%; text-align: left" class="row">
    <div class="column4" style="width: 125px">
      <a style="margin-left: 2vw; cursor: pointer" (click)="previousState()">
        <i class="material-icons">chevron_left</i>
      </a>
    </div>
    <div>
      <h1>
        Dispositivo: <b> {{ dependeHeader }} </b>
      </h1>
    </div>
  </div>

  <hr />

  <br />

  <div>
    <div class="row3" style="height: 300px">
      <div class="column4" style="width: 22%">
        <mat-card>
          <mat-card-header>
            <h3>Información del dispositivo</h3>
          </mat-card-header>
          <mat-card-subtitle>
            <span>
              <b>Nombre del dispositivo:</b> {{ datoActualuuidNombre }}
            </span>
            <i
              class="material-icons small"
              ngxClipboard
              [cbContent]="dato.tiene?.uuid"
              (cbOnSuccess)="copiado($event)"
              title="Copiar el uuid del dispositivo"
            >
              file_copy
            </i>
            <br />
            <b>Tipo de medición: </b>
            <span>
              {{ dato.es.nombre_es }}
              <i
                class="material-icons small"
                ngxClipboard
                [cbContent]="datoActualuuidMedicion"
                (cbOnSuccess)="copiado($event)"
                title="Copiar el uuid del tipo de medición"
              >
                file_copy
              </i>
            </span>
            <br />
            <b>uuid del dato: </b>
            {{ uuid }}
            <i
              class="material-icons small"
              ngxClipboard
              [cbContent]="uuid"
              (cbOnSuccess)="copiado($event)"
              title="Copiar el uuid del dato"
            >
              file_copy
            </i>
            <br />
            <br />
            <b>Incidencias del nodo: </b>
            <a
              style="cursor: pointer; padding: 10px"
              (click)="openAlertsComponent()"
              title="Mostrar historial de eventos del dato"
            >
              <mat-icon style="color: rgb(0, 64, 255)">search</mat-icon>
            </a>
            <!-- <span matBadge="{{alarmsCount}}" matBadgeOverlap="true"></span> -->
            <a
              style="cursor: pointer; padding-left: 15px"
              (click)="actOverDatoAlarm('silenciar', uuid)"
              title="Silenciar dato para no recibir más notificaciones"
            >
              <mat-icon style="color: rgb(255, 191, 0)">volume_off</mat-icon>
            </a>

            <a
              style="cursor: pointer; padding: 10px"
              (click)="actOverDatoAlarm('rearmar', uuid)"
              title="Rearmar dato para volver a recibir notificaciones"
            >
              <mat-icon style="color: green">volume_up</mat-icon>
            </a>

            <br />
            <div style="display: inline-block">
              <b>Franja horaria:</b>
            </div>
            <div
              style="display: inline-block; width: 205px; margin-left: 10px"
              *ngIf="roles.includes('admin'); else elseFranjaHoraria"
            >
              <mat-form-field>
                <mat-label>{{ "TIMEZONE.NAME" | translate }}</mat-label>
                <mat-select
                  (selectionChange)="cambiarZonaHoraria($event)"
                  [(value)]="zonaHorariaDato"
                  class="virtual-scroll"
                >
                  <mat-option
                    *ngFor="let timeZone of utcCollection"
                    [value]="timeZone"
                    class="example-item"
                  >
                    {{ timeZone }}
                    <div *ngIf="!timeZone">Loading...</div>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <ng-template #elseFranjaHoraria>
              {{ zonaHorariaDato }}
            </ng-template>
            <br />
            <span *ngIf="dato.periodo">
              <b>Periodo del dato:</b> {{ dato.periodo }}
            </span>
            <br />

            <br />

            <span
              *ngIf="
                (dato.calculaConnection.edges.length > 0 &&
                  dato.calculaConnection.edges[0].node.codigo == 'FORMULA') ||
                sinFuncion == 'FORMULA'
              "
            >
              <i
                class="material-icons help"
                style="cursor: help"
                title="Las fórmulas deberán seguir el patrón ${variable1}OPERACION${variable2}-...&#013;Por ejemplo: ${cp}-${sg}+${lp} o ${var1}/${var2}"
              >
                help
              </i>
              <b>Editar fórmula: </b>
              <input
                [(ngModel)]="dato.calculaConnection.edges[0].formula"
                style="border: 0; width: 150px"
                placeholder="{{
                  dato.calculaConnection.edges[0].formula ||
                    'Introducir fórmula'
                }}"
              />
              <i
                (click)="cambiarFormula()"
                class="material-icons"
                style="cursor: pointer"
              >
                send
              </i>
            </span>
            <span></span>
            <br />
            <div *ngIf="roles.includes('admin')">
              <b>Modificar atributos del dato:</b>
              <hr />
              <b>Introducir descripción:</b>
              <div>
                <textarea rows="3" cols="30" [(ngModel)]="datoDescripcion">
                            {{ datoDescripcion }}
                        </textarea
                >
              </div>
              <b>Límite Superior:</b>
              <br />
              <input
                type="number"
                id="limite-superior"
                [(ngModel)]="datoUpperLimit"
                placeholder="Introducir límite superior..."
              />
              <br />
              <b>Límite Inferior:</b>
              <br />
              <input
                type="number"
                id="limite-inferior"
                [(ngModel)]="datoLowerLimit"
                placeholder="Introducir límite inferior..."
              />
              <br />
              <div *ngIf="isCalculated">
                <br />
                <b>Fecha "desde" (epoch milisegundos UTC):</b>
                <br />
                <input
                  type="number"
                  id="fecha-desde"
                  [(ngModel)]="calculaDesde"
                  placeholder="Introducir fecha desde..."
                />
                {{ calculaDesde | getDatePipe }}
                <br />
                <b>Fecha "hasta" (epoch milisegundos UTC):</b>
                <br />
                <input
                  type="number"
                  id="fecha-hasta"
                  [(ngModel)]="calculaHasta"
                  placeholder="Introducir fecha hasta..."
                />
                {{ calculaHasta | getDatePipe }}
                <br />
              </div>
              <br />
              <button
                class="btn-primary accent-1"
                [disabled]="datoUpperLimit < datoLowerLimit"
                [ngClass]="{
                  'disabled-button': datoUpperLimit < datoLowerLimit
                }"
                (click)="
                  updateDatoAction(
                    datoDescripcion,
                    datoUpperLimit,
                    datoLowerLimit,
                    calculaDesde,
                    calculaHasta
                  )
                "
              >
                Actualizar información
              </button>
            </div>
          </mat-card-subtitle>
        </mat-card>
      </div>

      <div
        class="column4"
        style="height: 300px"
        *ngIf="roles.includes('admin')"
      >
        <mat-card class="mat-card-row3">
          <mat-grid-list cols="3" rowHeight="fit" style="height: 100%">
            <mat-grid-tile style="text-align: center">
              <mat-grid-tile-header [style.height]="panelHeight">
                <b>Función de cálculo</b>
              </mat-grid-tile-header>
              <div
                class="div-mat-grid-funcion"
                style="height: 300px; overflow: visible"
              >
                <div
                  style="width: 100%; margin-left: 1px; margin-top: 100px"
                  align="center"
                  *ngIf="dato.calculaConnection.edges.length > 0"
                >
                  <mat-form-field appearance="fill">
                    <mat-label>Selec. función</mat-label>
                    <mat-select
                      [(ngModel)]="dato.calculaConnection.edges[0].node"
                      name="asignarFuncion"
                      ngDefaultControl
                      (valueChange)="cambiarFuncion($event)"
                    >
                      <mat-option *ngFor="let f of opcionesFuncion" [value]="f">
                        {{ f.codigo }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <span
                    *ngIf="
                      dato.calculaConnection.edges.length > 0 &&
                      dato.calculaConnection.edges[0].node.codigo
                    "
                  >
                    Actual:
                    {{ dato.calculaConnection.edges[0].node.codigo }}</span
                  >
                </div>
                <div
                  style="width: 85%; margin-left: 15px; margin-top: 100px"
                  align="center"
                  *ngIf="dato.calculaConnection.edges.length == 0"
                >
                  <mat-form-field appearance="fill">
                    <mat-label>Selec. función</mat-label>
                    <mat-select
                      [(ngModel)]="sinFuncion"
                      name="asignarFuncion"
                      ngDefaultControl
                      (valueChange)="cambiarFuncion($event)"
                    >
                      <mat-option *ngFor="let f of opcionesFuncion" [value]="f">
                        {{ f.codigo }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span
                    *ngIf="
                      dato.calculaConnection.edges.length > 0 &&
                      dato.calculaConnection.edges[0].node.codigo
                    "
                  >
                    Actual: {{ dato.Connection.edges[0].node.codigo }}</span
                  >
                  <span *ngIf="!dato.calcula?.from"> </span>
                </div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile>
              <mat-grid-tile-header [style.height]="panelHeight">
                <b>Invalidado</b>
              </mat-grid-tile-header>
              <div
                class="div-mat-grid"
                [ngClass]="{
                  negative: dato.invalidated != null,
                  positive: dato.invalidated === null
                }"
              >
                {{ dato.invalidated | getDatePipe }}
              </div>
            </mat-grid-tile>
            <mat-grid-tile>
              <mat-grid-tile-header [style.height]="panelHeight">
                <b>Error</b>
                <span
                  style="display: block; float: right"
                  *ngIf="
                    dato.calculaConnection &&
                    dato.calculaConnection.edges &&
                    dato.calculaConnection.edges.length > 0
                  "
                >
                  <i
                    class="material-icons small"
                    ngxClipboard
                    [cbContent]="dato.calculaConnection?.edges[0].error"
                    (cbOnSuccess)="copiado($event)"
                    title="Copiar el error"
                    style="display: block"
                  >
                    file_copy
                  </i>
                </span>
              </mat-grid-tile-header>
              <div
                id="scrollerror"
                *ngIf="
                  dato.calculaConnection &&
                  dato.calculaConnection.edges &&
                  dato.calculaConnection.edges.length > 0
                "
                [ngClass]="{
                  negative: dato.calculaConnection?.edges[0].error,
                  positive: !dato.calculaConnection?.edges[0].error
                }"
              >
                <span
                  *ngIf="
                    dato.calculaConnection &&
                      dato.calculaConnection.edges[0].error;
                    else noErrorBlock
                  "
                >
                  {{ dato.calculaConnection?.edges[0].error }}
                </span>
                <ng-template #noErrorBlock> Sin error </ng-template>
              </div>
            </mat-grid-tile>

            <mat-grid-tile>
              <mat-grid-tile-header [style.height]="panelHeight">
                <b>Disabled</b>
              </mat-grid-tile-header>
              <div
                class="div-mat-grid"
                *ngIf="
                  dato.calculaConnection &&
                  dato.calculaConnection.edges &&
                  dato.calculaConnection.edges.length > 0
                "
                [ngClass]="{
                  negative:
                    dato.calculaConnection &&
                    dato.calculaConnection.edges[0].disabled != null,
                  positive:
                    dato.calculaConnection &&
                    dato.calculaConnection.edges[0].disabled == null
                }"
              >
                <span
                  *ngIf="
                    dato.calculaConnection &&
                    dato.calculaConnection.edges[0].disabled
                  "
                >
                  {{
                    dato.calculaConnection &&
                      dato.calculaConnection.edges[0].disabled | getDatePipe
                  }}
                </span>
              </div>
            </mat-grid-tile>
            <mat-grid-tile>
              <mat-grid-tile-header [style.height]="panelHeight">
                <b>Next</b>
              </mat-grid-tile-header>
              <div class="div-mat-grid">
                {{ dato.next | getDatePipe }}
              </div>
            </mat-grid-tile>
            <mat-grid-tile>
              <mat-grid-tile-header [style.height]="panelHeight">
                Recalcular
              </mat-grid-tile-header>
              <div class="div-mat-grid" class="positive">
                <a title="Recalcular el dato">
                  <i
                    (click)="[recalcularDato(), rotate()]"
                    [@rotatedState]="state"
                    class="material-icons rotate180"
                    id="refresh"
                  >
                    autorenew
                  </i>
                </a>
              </div>
            </mat-grid-tile>
          </mat-grid-list>
        </mat-card>
      </div>

      <div class="column4" style="height: 300px">
        <mat-card class="mat-card-row3">
          <mat-grid-list
            cols="3"
            rowHeight="fit"
            style="height: 100%; padding: 5px"
          >
            <mat-grid-tile style="text-align: center">
              <mat-grid-tile-header [style.height]="panelHeight">
                <b>Cantidad de datos</b>
              </mat-grid-tile-header>
              <div class="div-mat-grid">
                {{ dato.stats_count }}
              </div>
            </mat-grid-tile>
            <mat-grid-tile>
              <mat-grid-tile-header [style.height]="panelHeight">
                <b>Media</b>
              </mat-grid-tile-header>
              <div class="div-mat-grid">
                {{ dato.stats_mean | getToFixed }}
              </div>
            </mat-grid-tile>
            <mat-grid-tile>
              <mat-grid-tile-header [style.height]="panelHeight">
                <b>Percentil inferior</b>
              </mat-grid-tile-header>
              <div class="div-mat-grid">
                {{ dato.stats_pbottom | getToFixed }}
              </div>
            </mat-grid-tile>
            <mat-grid-tile>
              <mat-grid-tile-header [style.height]="panelHeight">
                <b>Percentil superior</b>
              </mat-grid-tile-header>
              <div class="div-mat-grid">
                {{ dato.stats_ptop | getToFixed }}
              </div>
            </mat-grid-tile>
            <mat-grid-tile>
              <mat-grid-tile-header [style.height]="panelHeight">
                <b>Desviación estándar</b>
              </mat-grid-tile-header>
              <div class="div-mat-grid">
                {{ dato.stats_stddev | getToFixed }}
              </div>
            </mat-grid-tile>
            <mat-grid-tile>
              <mat-grid-tile-header [style.height]="panelHeight">
                <b>Último valor recibido</b>
              </mat-grid-tile-header>
              <div class="div-mat-grid">
                {{ dato.stats_last | getToFixed }}
              </div>
            </mat-grid-tile>
          </mat-grid-list>
        </mat-card>
      </div>

      <div class="column4" style="height: 350px; width: 70%">
        <mat-card class="mat-card-row3">
          <mat-grid-list
            cols="1"
            rowHeight="fit"
            style="height: 100%; padding: 5px"
          >
            <mat-grid-tile style="text-align: center">
              <mat-grid-tile-header [style.height]="panelHeight">
                <b>Últimas 2 semanas de: {{ dato.es.nombre_es }} </b>
              </mat-grid-tile-header>
              <div class="div-mat-grid-svg-plot">
                <app-graphql-ts
                  [title]="null"
                  [graphConfig]="graphConfig"
                ></app-graphql-ts>
              </div>
            </mat-grid-tile>
          </mat-grid-list>
        </mat-card>
      </div>
      <!-- <div class="column4" style="height:450px">
        <mat-card class="mat-card-row3"> 
             <mat-grid-list cols="1" rowHeight="fit" style="height: 100%;padding:5px"> 
                <mat-grid-tile style = "text-align:center;">
                    <mat-grid-tile-header [style.height]="panelHeight"  >
                        <b>Tiempo real para: {{dato.es.nombre_es}}
                        </b>
                    </mat-grid-tile-header> 
                    <div class="height: 500px">
                         <app-rt-graphics 
                            [dataTraces] = "[trace]"
                            [data]="dataArrayIdentifiers" 
                            [layout]="configRT.layout" 
                            [config]="configRT.config">
                        </app-rt-graphics>  
                    </div>
             </mat-grid-tile>
           
             </mat-grid-list> 
             </mat-card> 
    </div> -->
    </div>
  </div>

  <hr style="margin-left: 2vw; width: 85%" />

  <!-- <h3 style="margin-left:2vw;margin-top: 15px">Sources que apuntan al dato actual:</h3> -->

  <mat-form-field class="filtro-tabla">
    <mat-label>Filtrar</mat-label>
    <input
      matInput
      (keyup)="applyFilterSources($event)"
      placeholder="Filtrar datos..."
    />
  </mat-form-field>

  <div
    class="mat-elevation-z8"
    style="width: 85%; margin-left: 2vw"
    align="center"
    [hidden]="loading"
  >
    <table mat-table [dataSource]="dataSourceSources">
      <ng-container matColumnDef="sourceuuid">
        <th mat-header-cell *matHeaderCellDef><b>uuid del Source</b></th>
        <td mat-cell *matCellDef="let d">
          <a
            style="padding-left: 15px"
            title="Navegar al source {{ d.node.nombre }}"
            [routerLink]="['/source', d.node.uuid]"
          >
            {{ d.node.uuid }}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="sourcetopic">
        <th mat-header-cell *matHeaderCellDef><b>Topic del Source</b></th>
        <td mat-cell *matCellDef="let d">
          {{ d.node.topic }}
        </td>
      </ng-container>

      <ng-container matColumnDef="entradauuid">
        <th mat-header-cell *matHeaderCellDef><b>uuid de la entrada</b></th>
        <td mat-cell *matCellDef="let d">
          {{ d.uuid }}
        </td>
      </ng-container>

      <ng-container matColumnDef="entradatopic">
        <th mat-header-cell *matHeaderCellDef><b>Topic de la entrada</b></th>
        <td mat-cell *matCellDef="let d">
          {{ d.topic }}
        </td>
      </ng-container>

      <ng-container matColumnDef="desde">
        <th mat-header-cell *matHeaderCellDef><b>Desde</b></th>
        <td mat-cell *matCellDef="let d">
          {{ (d.desde | getDatePipe) || "Sin fecha" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="hasta">
        <th mat-header-cell *matHeaderCellDef><b>Hasta</b></th>
        <td mat-cell *matCellDef="let d">
          {{ (d.hasta | getDatePipe) || "Sin fecha" }}
        </td></ng-container
      >

      <tr mat-header-row *matHeaderRowDef="displayedColumnsSources"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsSources"></tr>
    </table>
    <mat-paginator
      #TableSourcesPaginator="matPaginator"
      [pageSizeOptions]="[5, 10, 25]"
      showFirstLastButtons
      [hidden]="loading"
    ></mat-paginator>
  </div>

  <hr style="margin-left: 2vw; margin-top: 55px; width: 85%" />

  <h3 style="margin-left: 2vw">Datos de los que depende este:</h3>

  <mat-form-field class="filtro-tabla" style="margin-top: 30px">
    <mat-label>Filtrar</mat-label>
    <input
      matInput
      (keyup)="applyFilterTo($event)"
      placeholder="Filtrar datos..."
    />
  </mat-form-field>

  <div align="center" style="width: 85%" [hidden]="!loading">
    <mat-progress-spinner
      mode="indeterminate"
      strokeWidth="3"
      value="7"
      diameter="75"
      style="margin: 0 auto"
    ></mat-progress-spinner>
  </div>

  <div
    class="mat-elevation-z8"
    style="width: 85%; margin-left: 2vw"
    align="center"
    [hidden]="loading"
  >
    <table mat-table [dataSource]="dataSourceTo">
      <ng-container matColumnDef="uuidDato">
        <th mat-header-cell *matHeaderCellDef><b>dependencia</b></th>
        <td mat-cell *matCellDef="let d">
          <span
            ngxClipboard
            [cbContent]="d.node.uuid"
            (cbOnSuccess)="copiado($event)"
          >
            <span
              *ngIf="
                d.node.calculaConnection.edges.length == 0 ||
                (d.node.calculaConnection.edges.length > 0 &&
                  !d.node.calculaConnection.disabled)
              "
            >
              {{ d.node.uuid }}
            </span>
            <span
              *ngIf="
                d.node.calculaConnection.edges.length > 0 &&
                d.node.calculaConnection.disabled
              "
            >
              <i
                class="material-icons warning"
                title="Dato invalidado. Navega para identificar el problema."
              >
                warning
              </i>
              {{ d.node.uuid }}
            </span>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="nombreDispositivo">
        <th mat-header-cell *matHeaderCellDef><b>Nombre del dispositivo</b></th>
        <td
          mat-cell
          *matCellDef="let d"
          ngxClipboard
          [cbContent]="d.node.tieneConnection.edges[0].node.uuid"
          (cbOnSuccess)="copiado($event)"
        >
          {{ d.node.tieneConnection.edges[0].node.nombre }}
        </td>
      </ng-container>

      <ng-container matColumnDef="tipoDato">
        <th mat-header-cell *matHeaderCellDef><b>Tipo de medicion</b></th>
        <td
          mat-cell
          *matCellDef="let d"
          ngxClipboard
          [cbContent]="d.node.es.uuid"
          (cbOnSuccess)="copiado($event)"
        >
          {{ d.node.es.nombre }}
        </td>
      </ng-container>

      <ng-container matColumnDef="formula">
        <th mat-header-cell *matHeaderCellDef><b>Variable</b></th>
        <td mat-cell *matCellDef="let d">
          <span *ngIf="d.variable"> {{ d.variable }} </span>
          <span *ngIf="!d.variable"> Sin variable </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="datosTotales">
        <th mat-header-cell *matHeaderCellDef><b>Cantidad de datos</b></th>
        <td mat-cell *matCellDef="let d">{{ d.node.stats_count }}</td>
      </ng-container>

      <ng-container matColumnDef="next">
        <th mat-header-cell *matHeaderCellDef><b> Next </b></th>
        <td mat-cell *matCellDef="let d">{{ d.node.next | getDatePipe }}</td>
      </ng-container>

      <ng-container matColumnDef="invalidated">
        <th mat-header-cell *matHeaderCellDef><b> Invalidado </b></th>
        <td mat-cell *matCellDef="let d">
          {{ d.node.invalidated | getDatePipe }}
        </td>
      </ng-container>

      <ng-container matColumnDef="limiteInferior">
        <th mat-header-cell *matHeaderCellDef><b> Limite inferior </b></th>
        <td mat-cell *matCellDef="let d">
          <span *ngIf="d.node.stats_pbottom != null">
            {{ d.node.stats_pbottom.toFixed(2) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="limiteSuperior">
        <th mat-header-cell *matHeaderCellDef><b> Limite superior </b></th>
        <td mat-cell *matCellDef="let d">
          <span *ngIf="d.node.stats_ptop != null">
            {{ d.node.stats_ptop.toFixed(2) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="mediana">
        <th mat-header-cell *matHeaderCellDef><b> Mediana </b></th>
        <td mat-cell *matCellDef="let d">
          <span *ngIf="d.node.stats_median != null">
            {{ d.node.stats_median.toFixed(2) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="desviacion">
        <th mat-header-cell *matHeaderCellDef><b> Desviacion </b></th>
        <td mat-cell *matCellDef="let d">
          <span *ngIf="d.node.stats_stddev != null">
            {{ d.node.stats_stddev.toFixed(2) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="fCalculo">
        <th mat-header-cell *matHeaderCellDef><b> Funcion calculo </b></th>
        <td mat-cell *matCellDef="let d">
          <span *ngIf="d.node.calculaConnection.edges.length > 0">
            {{ d.node.calculaConnection.edges[0].node.codigo }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="dependen">
        <th mat-header-cell *matHeaderCellDef><b> Dependencias </b></th>
        <td mat-cell *matCellDef="let d">
          <span *ngIf="d.node.dependeToConnection">
            {{ d.node.dependeToConnection.edges.length }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="botones">
        <th mat-header-cell *matHeaderCellDef><b>Acción</b></th>
        <td mat-cell *matCellDef="let d" align="center">
          <div
            class="btn-group"
            style="text-align: center; margin: auto; display: block"
          >
            <a
              style="padding-left: 15px"
              title="Navegar al dato {{ d.node.es.nombre }}"
              [routerLink]="['/dato', d.node.uuid]"
            >
              <i class="material-icons" style="color: #303f9f; cursor: pointer">
                forward
              </i>
            </a>

            <a
              (click)="deleteDependency(d)"
              style="padding-top: -5px; padding-left: 0.7vw"
              title="Eliminar el dato {{ d.node.es.nombre }}"
            >
              <i
                class="material-icons"
                style="color: rgb(168, 26, 26); cursor: pointer"
              >
                delete
              </i>
            </a>

            <a
              (click)="[saveData(d), open(contentFormula)]"
              style="padding-top: -5px; padding-left: 0.7vw"
              title="Editar la variable del dato {{ d.node.es.nombre }}"
            >
              <i
                class="material-icons"
                style="color: rgb(18, 116, 10); cursor: pointer"
              >
                edit
              </i>
            </a>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsTo"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsTo"></tr>
    </table>
    <mat-paginator
      #TableToPaginator="matPaginator"
      [pageSizeOptions]="[5, 10, 25]"
      showFirstLastButtons
      [hidden]="loading"
    ></mat-paginator>
  </div>

  <div
    *ngIf="roles.includes('admin')"
    align="center"
    style="margin-left: 2vw; width: 85%; margin-top: 45px"
    [hidden]="loading"
  >
    <button
      mat-fab
      class="add-dependencia"
      (click)="navegacionDependenciasTo()"
      title="Añadir un nuevo dato del que dependa  {{ dependeHeader }}"
    >
      <h4>+</h4>
    </button>
  </div>

  <hr style="margin-left: 2vw; padding-top: 15px; width: 85%" />

  <h3 style="margin-left: 2vw; padding-top: 15px">
    Datos que dependen de este
  </h3>

  <br />

  <mat-form-field class="filtro-tabla">
    <mat-label>Filtrar</mat-label>
    <input
      matInput
      (keyup)="applyFilterFrom($event)"
      placeholder="Filtrar datos..."
    />
  </mat-form-field>

  <div align="center" style="width: 85%" [hidden]="!loading">
    <mat-progress-spinner
      mode="indeterminate"
      strokeWidth="3"
      value="7"
      diameter="75"
      style="margin: 0 auto"
    ></mat-progress-spinner>
  </div>

  <div
    class="mat-elevation-z8"
    style="width: 85%; margin-left: 2vw"
    align="center"
    [hidden]="loading"
  >
    <table mat-table [dataSource]="dataSourceFrom">
      <ng-container matColumnDef="uuidDato">
        <th mat-header-cell *matHeaderCellDef><b>dependencia</b></th>
        <td mat-cell *matCellDef="let d">
          <span
            ngxClipboard
            [cbContent]="d.node.uuid"
            (cbOnSuccess)="copiado($event)"
          >
            <span
              *ngIf="
                d.node.calculaConnection.edges.length == 0 ||
                (d.node.calculaConnection.edges.length > 0 &&
                  !d.node.calculaConnection.disabled)
              "
            >
              {{ d.node.uuid }}
            </span>
            <span
              *ngIf="
                d.node.calculaConnection.edges.length > 0 &&
                d.node.calculaConnection.disabled
              "
            >
              <i
                class="material-icons warning"
                title="Dato invalidado. Navega para identificar el problema."
              >
                warning
              </i>
              {{ d.node.uuid }}
            </span>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="nombreDispositivo">
        <th mat-header-cell *matHeaderCellDef><b>Nombre del dispositivo</b></th>
        <td
          mat-cell
          *matCellDef="let d"
          ngxClipboard
          [cbContent]="d.node.tieneConnection.edges[0].node.nombre"
          (cbOnSuccess)="copiado($event)"
        >
          {{ d.node.tieneConnection.edges[0].node.nombre }}
        </td>
      </ng-container>

      <ng-container matColumnDef="tipoDato">
        <th mat-header-cell *matHeaderCellDef><b>Tipo de medicion</b></th>
        <td
          mat-cell
          *matCellDef="let d"
          ngxClipboard
          [cbContent]="d.node.es.uuid"
          (cbOnSuccess)="copiado($event)"
        >
          {{ d.node.es.nombre }}
        </td>
      </ng-container>

      <ng-container matColumnDef="formula">
        <th mat-header-cell *matHeaderCellDef><b>Variable</b></th>
        <td mat-cell *matCellDef="let d">
          <span *ngIf="d.variable"> {{ d.variable }} </span>
          <span *ngIf="!d.variable"> Sin variable </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="datosTotales">
        <th mat-header-cell *matHeaderCellDef><b>Cantidad de datos</b></th>
        <td mat-cell *matCellDef="let d">{{ d.node.stats_count }}</td>
      </ng-container>

      <ng-container matColumnDef="next">
        <th mat-header-cell *matHeaderCellDef><b> Next </b></th>
        <td mat-cell *matCellDef="let d">{{ d.node.next | getDatePipe }}</td>
      </ng-container>

      <ng-container matColumnDef="invalidated">
        <th mat-header-cell *matHeaderCellDef><b> Invalidado </b></th>
        <td mat-cell *matCellDef="let d">
          {{ d.node.invalidated | getDatePipe }}
        </td>
      </ng-container>

      <ng-container matColumnDef="limiteInferior">
        <th mat-header-cell *matHeaderCellDef><b> Limite inferior </b></th>
        <td mat-cell *matCellDef="let d">
          <span *ngIf="d.node.stats_pbottom != null">
            {{ d.node.stats_pbottom.toFixed(2) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="limiteSuperior">
        <th mat-header-cell *matHeaderCellDef><b> Limite superior </b></th>
        <td mat-cell *matCellDef="let d">
          <span *ngIf="d.node.stats_ptop != null">
            {{ d.node.stats_ptop.toFixed(2) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="mediana">
        <th mat-header-cell *matHeaderCellDef><b> Mediana </b></th>
        <td mat-cell *matCellDef="let d">
          <span *ngIf="d.node.stats_median != null">
            {{ d.node.stats_median.toFixed(2) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="desviacion">
        <th mat-header-cell *matHeaderCellDef><b> Desviacion </b></th>
        <td mat-cell *matCellDef="let d">
          <span *ngIf="d.node.stats_stddev != null">
            {{ d.node.stats_stddev.toFixed(2) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="fCalculo">
        <th mat-header-cell *matHeaderCellDef><b> Funcion calculo </b></th>
        <td mat-cell *matCellDef="let d">
          <span *ngIf="d.node.calculaConnection.edges.length > 0">
            {{ d.node.calculaConnection.edges[0].node.codigo }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="dependen">
        <th mat-header-cell *matHeaderCellDef><b> Dependencias </b></th>
        <td mat-cell *matCellDef="let d">
          <span *ngIf="d.node.dependeToConnection">
            {{ d.node.dependeToConnection.edges.length }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="botones">
        <th mat-header-cell *matHeaderCellDef><b>Acción</b></th>
        <td mat-cell *matCellDef="let d" align="center">
          <div
            class="btn-group"
            style="text-align: center; margin: auto; display: block"
          >
            <a
              style="padding-left: 15px"
              title="Navegar al dato {{ d.node.es.nombre }}"
              [routerLink]="['/dato', d.node.uuid]"
            >
              <i class="material-icons" style="color: #303f9f; cursor: pointer">
                forward
              </i>
            </a>
            <div *ngIf="roles.includes('admin')">
              <a
                (click)="deleteDependency(d)"
                style="padding-top: -5px; padding-left: 0.7vw"
                title="Eliminar el dato {{ d.node.es.nombre }}"
              >
                <i
                  class="material-icons"
                  style="color: rgb(168, 26, 26); cursor: pointer"
                >
                  delete
                </i>
              </a>

              <a
                (click)="[saveData(d), open(contentFormula)]"
                style="padding-top: -5px; padding-left: 0.7vw"
                title="Editar la variable del dato {{ d.node.es.nombre }}"
              >
                <i
                  class="material-icons"
                  style="color: rgb(18, 116, 10); cursor: pointer"
                >
                  edit
                </i>
              </a>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsTo"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsTo"></tr>
    </table>
    <mat-paginator
      #TableToPaginator="matPaginator"
      [pageSizeOptions]="[5, 10, 25]"
      showFirstLastButtons
      [hidden]="loading"
    ></mat-paginator>
  </div>

  <br />

  <ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">
        Actualizar información de la medición <b>{{ nombreHeader }}</b>
        del dispositivo
        <b> {{ dependeHeader }} </b>
      </h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form>
        <div class="form-group">
          <label for="uuid"><b>UUID</b></label>
          <div class="input-group">
            <input
              type="text"
              [(ngModel)]="uuid"
              class="form-control"
              name="uuid"
              id="uuid"
              disabled
            />
          </div>
          <label for="nombre"><b>Uuid de la nueva dependencia</b></label>
          <div class="input-group">
            <input
              type="numeric"
              id="uuidDependencia"
              class="form-control"
              name="uuidDependencia"
              autocomplete="off"
              [(ngModel)]="uuidDependencia"
            />
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        id="boton-cerrar-modal"
        class="btn btn-secondary"
        (click)="modal.dismiss()"
      >
        Cerrar
      </button>
      <button
        type="button"
        id="boton-enviar-datos-modal"
        class="btn btn-outline-dark"
        [disabled]="false"
        (click)="[addDependency(), modal.close('Save click')]"
      >
        Actualizar datos
      </button>
    </div>
  </ng-template>

  <ng-template #contentFormula let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">
        Actualizar información del dato <b>{{ dato.es.nombre }}</b> del
        dispositivo <b>{{ dato.tiene.nombre }}</b>
      </h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form>
        <div class="form-group">
          <div class="input-group" style="width: 300px" [hidden]="introManual">
            <label for="variableModal"><b>Valor en la formula</b></label>
            <ngx-select-dropdown
              style="width: 300px"
              name="variableModal"
              [multiple]="false"
              [(ngModel)]="variableModal"
              [config]="config"
              aria-placeholder="aaa"
              placeholder="Seleccionar variable"
              [options]="opcionesVariableModal"
            >
            </ngx-select-dropdown>
          </div>
          <input
            type="checkbox"
            [value]="introManual"
            (change)="habilitarManual($event)"
          />
          <label for="k"><b>Habilitar la introducción manual</b></label>
          <div [hidden]="!introManual">
            <label><b>Introducir variable manualmente</b></label>
            <div class="input-group" style="width: 300px">
              <input
                type="text"
                name="variableManualModal"
                [(ngModel)]="variableManualModal"
              />
            </div>
          </div>
          <label><b>Introducir formula en la dependencia </b></label>
          <div>
            <textarea
              rows="3"
              cols="40"
              name="formulaDependencia"
              [(ngModel)]="formulaDependencia"
            >
                        {{ formulaDependencia }}
                    </textarea
            >
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        id="boton-cerrar-modal"
        class="btn btn-secondary"
        (click)="modal.dismiss()"
      >
        Cerrar
      </button>
      <button
        type="button"
        id="boton-enviar-datos-modal"
        class="btn btn-outline-dark"
        [disabled]="false"
        (click)="
          [cambiarVariable(), actualizarFormulaDep(), modal.close('Save click')]
        "
      >
        Actualizar datos
      </button>
    </div>
  </ng-template>

  <ng-template #contentFormulaTotal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">
        Actualizar la fórmula del dato <b>{{ dato.es.nombre }}</b> del
        dispositivo <b>{{ dato.tiene.nombre }}</b>
      </h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form>
        <div class="form-group">
          <label for="uuidDato"><b>uuid del dato</b></label>
          <div class="input-group" style="width: 350px">
            <input
              type="text"
              style="width: 100%"
              name="uuidDato"
              [(ngModel)]="dato.uuid"
              disabled
            />
          </div>
          <label for="formulaDato"><b>Valor en la formula</b></label>
          <div class="input-group" style="width: 350px">
            <input
              type="text"
              style="width: 100%"
              name="formula"
              [(ngModel)]="dato.calcula.formula"
            />
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        id="boton-cerrar-modal"
        class="btn btn-secondary"
        (click)="modal.dismiss()"
      >
        Cerrar
      </button>
      <button
        type="button"
        id="boton-enviar-datos-modal"
        class="btn btn-outline-dark"
        [disabled]="false"
        (click)="[modal.close('Save click')]"
      >
        Actualizar formula
      </button>
    </div>
  </ng-template>
</div>

<div align="center" style="width: 85%" [hidden]="!loading">
  <mat-progress-spinner
    mode="indeterminate"
    strokeWidth="3"
    value="7"
    diameter="75"
    style="margin: 0 auto"
  ></mat-progress-spinner>
</div>
